import React from 'react';
import { useWatch } from 'react-hook-form';
import { BooleanInput, TextInput, useRecordContext } from 'react-admin';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import InfoPopover from '../../../../layout/InfoPopover';

const ResetStatisticalTracking = ({
  disabled,
}: {
  disabled?: boolean;
}) => {
  const shouldResetStatistics = useWatch({ name: 'shouldResetStatistics' });
  const record = useRecordContext();
  // A reset starts a new Origination Chain, which the Risk Factor migration can't follow
  const hasScore = (record?.score ?? 0) > 0;

  return (
    <Card sx={{ backgroundColor: 'background.default', margin: 0 }}>
      <CardContent>
        <Typography color="primary.main" variant="h5" marginBottom={2}>
          Reset statistical tracking
          <InfoPopover
            key="email"
            title="Reset statistical tracking"
            content={(
              <>
                Resetting the statistical tracking will allow the new version of this rule to
                gather data independently, starting fresh without any influence from earlier
                versions. This means that the statistics from previous versions will remain
                unchanged.
                <br />
                <br />
                Alternatively, if you choose not to reset the statistical tracking, the new
                version will compile its statistics together with those from previous versions.
              </>
            )}
          />
        </Typography>
        <Typography>
          When doing larger changes to a rule, it can be beneficial to reset statistical
          tracking. This would treat the rule as new from a statistical perspective.
        </Typography>
        <Box marginTop={3}>
          <BooleanInput
            source="shouldResetStatistics"
            label="Reset statistical tracking"
            disabled={disabled || hasScore}
            helperText={hasScore
              ? 'Rules with a score can no longer reset their statistics.'
              : false}
          />
        </Box>
        {shouldResetStatistics && (
          <Box display="flex" flexDirection="column" gap={2} marginTop={3}>
            <Typography variant="label">
              Update the name of the rule to differentiate it (Optional)
            </Typography>
            <TextInput
              source="customName"
              label="Rule name"
              fullWidth
              disabled={disabled}
              helperText={false}
            />
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default ResetStatisticalTracking;
